import {mapMutations} from "vuex";

const errorMixin = {
    methods: {
        ...mapMutations({
            setMessageModel: 'setMessageModel'
        }),
        showErrorModal(errorMessage, settings = {}) {

            const checkTranslate = (value, defaultVal) => {
                if (value) {
                    var result = value
                    if (value.split(' ').length <= 1) {
                        try {
                            let translated = this.translate(value)
                            if (translated !== undefined) {
                                result = translated
                            }
                        } catch (e) {
                        }
                    }
                    return result
                } else {
                    return this.translate(defaultVal)
                }
            }

            const translatedMessage = checkTranslate(errorMessage, 'Sync_status')
            const title = checkTranslate(settings.title, 'Error')
            this.setMessageModel({
                msg: translatedMessage,
                duration: settings.duration
            })

        }
    },
};

export default errorMixin;
